/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type RoleTemplateFormModal_organization$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type EditRoleTemplateModalView_organization$ref: FragmentReference;
declare export opaque type EditRoleTemplateModalView_organization$fragmentType: EditRoleTemplateModalView_organization$ref;
export type EditRoleTemplateModalView_organization = {|
  +$fragmentRefs: RoleTemplateFormModal_organization$ref,
  +$refType: EditRoleTemplateModalView_organization$ref,
|};
export type EditRoleTemplateModalView_organization$data = EditRoleTemplateModalView_organization;
export type EditRoleTemplateModalView_organization$key = {
  +$data?: EditRoleTemplateModalView_organization$data,
  +$fragmentRefs: EditRoleTemplateModalView_organization$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EditRoleTemplateModalView_organization",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RoleTemplateFormModal_organization"
    }
  ],
  "type": "Organization",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = 'ab6ff1bd73ded08ea86599501f1478c6';

module.exports = node;
